import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import gsap from 'gsap';

//All Pages Animation Class
import Animation from './animation';
const animation = new Animation();

// Variables
const mqlLg = window.matchMedia('(min-width: 1024px)');

// Nav
const nav = document.getElementById('nav');
const navButton = document.getElementById('nav-button');
const navItems = document.querySelectorAll('.js-nav-item');

if (navButton && nav) {
  navButton.addEventListener('click', () => {
    navButton.classList.toggle('is-opened');
    nav.classList.toggle('is-opened');
  });

  navItems.forEach((item) => {
    item.addEventListener('click', () => {
      navButton.classList.remove('is-opened');
      nav.classList.remove('is-opened');
    });
  });
}

// Switch why data image in top
const whyDataItems =
  document.querySelectorAll<HTMLElement>('.js-why-data-item');
const whyDataImages =
  document.querySelectorAll<HTMLElement>('.js-why-data-image');

const options: IntersectionObserverInit = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5,
};

const observerCallback: IntersectionObserverCallback = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const index = Array.from(whyDataItems).indexOf(
        entry.target as HTMLElement
      );

      if (index !== -1) {
        whyDataImages.forEach((image, i) => {
          if (i === index) {
            image.classList.add('is-active');
          } else {
            image.classList.remove('is-active');
          }
        });
      }
    }
  });
};

const observer = new IntersectionObserver(observerCallback, options);

whyDataItems.forEach((item) => {
  observer.observe(item);
});

// People swiper in top
const topPeopleSwiper = document.querySelector(
  '.js-top-people-swiper'
) as HTMLElement;

if (topPeopleSwiper) {
  const swiper = new Swiper(topPeopleSwiper, {
    init: false,
    loop: true,
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    centeredSlides: true,
    grabCursor: false,
    navigation: {
      nextEl: '.js-top-people-button-next',
      prevEl: '.js-top-people-button-prev',
    },
    allowTouchMove: false,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      1024: {
        slidesPerView: 2.6,
        spaceBetween: '8.34%',
        centeredSlides: true,
      },
    },
    on: {
      slideChangeTransitionStart: () => {
        updateImagePosition(swiper);
      },
      init: () => {
        updateImagePosition(swiper);
      },
    },
  });

  swiper.init();
}

function updateImagePosition(swiper: Swiper) {
  const slides = swiper.slides;
  slides.forEach((slide: HTMLElement) => {
    const description = slide.querySelector('.js-people-description');
    const image = slide.querySelector('.js-people-image');
    if (description && image) {
      const descriptionHeight = description.clientHeight;
      const isPrevSlide = slide.classList.contains('swiper-slide-prev');
      const isNextSlide = slide.classList.contains('swiper-slide-next');

      if ((isPrevSlide || isNextSlide) && mqlLg.matches) {
        (
          image as HTMLElement
        ).style.transform = `translateY(${descriptionHeight}px)`;
      } else {
        (image as HTMLElement).style.transform = 'translateY(0)';
      }
    }
  });
}

// People Swiper
const peopleSwiper = document.querySelector('.js-people-swiper') as HTMLElement;

if (peopleSwiper) {
  const swiper = new Swiper(peopleSwiper, {
    init: false,
    loop: true,
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    allowTouchMove: false,
    navigation: {
      nextEl: '.js-people-button-next',
      prevEl: '.js-people-button-prev',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1.5,
        spaceBetween: 80,
      },
    },
  });

  swiper.init();
}

// Related contents swiper
const relatedSwiper = document.querySelector('.js-related-swiper');

if (relatedSwiper) {
  let swiper: Swiper | null = null;

  const checkBreakpoint = (e: MediaQueryListEvent) => {
    if (!e.matches) {
      initSwiper();
    } else if (swiper) {
      swiper.destroy(false, true);
    }
  };

  const checkInitialBreakpoint = () => {
    if (!mqlLg.matches) {
      initSwiper();
    } else if (swiper) {
      swiper.destroy(false, true);
    }
  };

  const initSwiper = () => {
    swiper = new Swiper('.js-related-swiper', {
      init: false,
      loop: false,
      slidesPerView: 1.15,
      spaceBetween: '12.5%',
    });

    swiper.init();
  };

  mqlLg.addEventListener('change', checkBreakpoint);
  checkInitialBreakpoint();
}

// brand movie in top
const brandMovieSection = document.getElementById(
  'brand-movie-section'
) as HTMLElement;

if (brandMovieSection) {
  const brandMovie = document.querySelector(
    '#brand-movie-section video'
  ) as HTMLVideoElement;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!brandMovie.src) {
            brandMovie.src =
              'https://recruit.datumstudio.jp/wp-content/themes/theme/assets/movie/DATUM_STUDIO_short.mp4';
            brandMovie.play();
          }
          observer.unobserve(brandMovieSection);
        }
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(brandMovieSection);
}

// Popup brand movie
const brandMovieContainer = document.getElementById(
  'brand-movie'
) as HTMLElement;
const brandMovie = document.querySelector(
  '#brand-movie video'
) as HTMLVideoElement;
const playButtons = document.querySelectorAll(
  '.js-play-movie-button'
) as NodeListOf<HTMLButtonElement>;
const closeButtons = document.querySelectorAll(
  '.js-close-movie-button'
) as NodeListOf<HTMLButtonElement>;

let isSrcSet = false;

if (brandMovieContainer && brandMovie) {
  if (playButtons.length > 0) {
    playButtons.forEach((playButton) => {
      playButton.addEventListener('click', () => {
        if (!isSrcSet) {
          brandMovie.src =
            'https://recruit.datumstudio.jp/wp-content/themes/theme/assets/movie/DATUM_STUDIO_long.mp4';
          isSrcSet = true;
        }
        brandMovieContainer.classList.add('is-opened');
        brandMovie.muted = false;
        brandMovie.play();
      });
    });
  }

  if (closeButtons.length > 0) {
    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        brandMovieContainer.classList.remove('is-opened');
        brandMovie.pause();
      });
    });
  }
}

const singleInterview = document.getElementById('single-interview');

if (singleInterview) {
  const sections = document.querySelectorAll('.js-interview-section');
  const navList = document.querySelector('#page-nav ul');

  if (navList) {
    sections.forEach((section, index) => {
      const sectionId = `section-${index + 1}`;

      const headingElement = section.querySelector('.js-h2-text') as HTMLElement;
      const headingText = headingElement
        ? headingElement.textContent?.trim() || `Section ${index + 1}`
        : `Section ${index + 1}`;

      const li = document.createElement('li');
      li.id = `nav-section-${index + 1}`;

      const anchor = document.createElement('a');
      anchor.href = `#${sectionId}`;
      anchor.classList.add('js-page-nav-item', 'text-white', 'lg:opacity-40');

      anchor.classList.add('lg:[&.is-active]:opacity-100');

      anchor.textContent = headingText;

      li.appendChild(anchor);

      navList.appendChild(li);

      section.id = sectionId;
    });
  }

}

// Page nav
const pageNav = document.getElementById('page-nav');

if (pageNav) {
  const navItems = document.querySelectorAll('.js-page-nav-item');
  const sections = document.querySelectorAll('.js-page-section');

  const observerOptions = {
    root: null,
    rootMargin: '-20% 0px -90% 0px',
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const targetId = entry.target.getAttribute('id');
      const navItem = document.querySelector(
        `.js-page-nav-item[href="#${targetId}"]`
      );

      if (entry.isIntersecting) {
        navItems.forEach((item) => {
          item.classList.remove('is-active');
        });

        if (navItem) {
          navItem.classList.add('is-active');
        }
      }
    });
  }, observerOptions);

  sections.forEach((section) => {
    observer.observe(section);
  });
}

// According
const details = document.querySelectorAll('.js-details');
const IS_OPENED_CLASS = 'is-opened';

details.forEach((element) => {
  const summary = element.querySelector('.js-summary');
  const content = element.querySelector('.js-content');

  if (summary) {
    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (element.classList.contains(IS_OPENED_CLASS)) {
        element.classList.toggle(IS_OPENED_CLASS);

        closingAnim(content, element).restart();
      } else {
        element.classList.toggle(IS_OPENED_CLASS);

        element.setAttribute('open', 'true');

        openingAnim(content).restart();
      }
    });
  }
});

const closingAnim = (content: gsap.TweenTarget, element: Element) =>
  gsap.to(content, {
    height: 0,
    duration: 0.4,
    ease: 'power3.out',
    overwrite: true,
    onComplete: () => {
      element.removeAttribute('open');
    },
  });

const openingAnim = (content: gsap.TweenTarget) =>
  gsap.fromTo(
    content,
    {
      height: 0,
    },
    {
      height: 'auto',
      duration: 0.4,
      ease: 'power3.out',
      overwrite: true,
    }
  );

const toggleButton = document.querySelector(
  '.js-tag-toggle-button'
) as HTMLButtonElement;
const accordionContent = document.querySelector(
  '.js-tag-accordion'
) as HTMLElement;

if (toggleButton && accordionContent) {
  let isOpen = false;

  toggleButton.addEventListener('click', () => {
    if (isOpen) {
      closingAnim(accordionContent, accordionContent);
      toggleButton.classList.remove('is-opened');
      const text = toggleButton.querySelector('.js-in-text') as HTMLElement;
      text.textContent = 'すべて見る';
    } else {
      openingAnim(accordionContent);
      toggleButton.classList.add('is-opened');
      const text = toggleButton.querySelector('.js-in-text') as HTMLElement;
      text.textContent = '閉じる';
    }
    isOpen = !isOpen;
  });
}
